import { Routes } from '@angular/router';

export const availableRoutes: Routes = [
  {
    // @extract(SIDEBAR.Servers)
    path: 'servers',
    loadChildren: () => import('src/app/modules/servers/servers.module').then(m => m.ServersModule),
    data: {
      scopeName: 'servers',
      title: 'Servers',
      icon: 'action:ic_view_list_24px'
    }
  },
  {
    // @extract(SIDEBAR.Sshkeys)
    path: 'sshkeys',
    loadChildren: () => import('src/app/modules/ssh/ssh.module').then(m => m.SshModule),
    data: {
      scopeName: 'sshkeys',
      title: 'Sshkeys',
      icon: 'action:ic_fingerprint_24px'
    }
  },
  {
    // @extract(SIDEBAR.Zones)
    path: 'zones',
    loadChildren: () => import('src/app/modules/zones/zones.module').then(m => m.ZonesModule),
    data: {
      scopeName: 'zones',
      title: 'Zones',
      icon: 'action:ic_donut_large_24px'
    }
  },
  {
    // @extract(SIDEBAR.Flavours)
    path: 'flavours',
    loadChildren: () => import('src/app/modules/tariff/tariff.module').then(m => m.TariffModule),
    data: {
      scopeName: 'tariffs',
      title: 'Flavours',
      icon: 'action:ic_touch_app_24px'
    }
  },
  {
    // @extract(SIDEBAR.Domains)
    path: 'domains',
    loadChildren: () => import('src/app/modules/domains/domains.module').then(m => m.DomainsModule),
    data: {
      scopeName: 'nameserver',
      title: 'Domains',
      icon: 'action:ic_language_24px'
    }
  },
  {
    // @extract(SIDEBAR.Networks)
    path: 'networks',
    loadChildren: 'src/app/modules/networks/networks.module#NetworksModule',
    data: {
      scopeName: 'networks',
      title: 'Networks',
      icon: 'action:ic_settings_input_hdmi_24px'
    }
  },
  {
    // @extract(SIDEBAR.Volumes)
    path: 'volumes',
    loadChildren: () => import('src/app/modules/disks/disks.module').then(m => m.DisksModule),
    data: {
      scopeName: 'block',
      title: 'Volumes',
      icon: 'action:ic_dns_24px'
    }
  },
  {
    // @extract(SIDEBAR.Compute)
    path: 'compute',
    loadChildren: () => import('src/app/modules/compute/compute.module').then(m => m.ComputeModule),
    data: {
      scopeName: 'compute',
      title: 'Compute',
      icon: 'action:ic_dns_24px'
    }
  },
  {
    // @extract(SIDEBAR.Accounts)
    path: 'accounts',
    loadChildren: () => import('src/app/modules/accounts/accounts.module').then(m => m.AccountsModule),
    data: {
      scopeName: 'accounts',
      title: 'Accounts',
      icon: 'action:ic_dns_24px'
    }
  }
];
